import { resolveAssetUrl } from "../../../utils/resolveAssetUrl";
import { useForm } from "../context";

const BannerTop = () => {
  const { checkout, firstItem } = useForm();

  const topBanner = checkout.styleConfig?.topBanner;

  if (!topBanner || Array.isArray(topBanner) || typeof topBanner !== 'string') {
    return null;
  }

  return (
    <img loading='lazy' src={resolveAssetUrl(topBanner)} alt={firstItem?.description} className='object-cover w-full rounded-lg' />
  );
};

export default BannerTop;
